module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/evie-shaffer-bkg-4cf6da47cca914c29842cb9c277a4d12.jpg";